module.exports = __webpack_public_path__ + "img/orden.d1331403.svg";